import React, {useState} from "react";
import { Box, useTheme, IconButton, Button,    CircularProgress, } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link,  useLocation, useNavigate } from 'react-router-dom';


import { useGetReportedCustomerDetailQuery } from "state/api";
import { useUpdateDisableUserMutation } from "state/api";
import { Header } from "components";

// Customers
const ReportedCustomerDetail = () => {
  // theme
  const theme = useTheme();
  const state = useLocation();
  const navigate = useNavigate();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false); // State for loading indicator

  const [disableUser] = useUpdateDisableUserMutation();


  const {name, _id, email, username, reportCount} = state.state;

    // const [updateDisableUser] = useUpdateDisableUserQuery();

    // const handleDisable = async () => {
    //     const res = await updateDisableUser(_id);
    //     console.log(res);
    // }


  // get data
  const { data, isLoading } = useGetReportedCustomerDetailQuery(_id);

  // data columns
const columns = [
    {
        field: "_id",
        headerName: "ID",
        flex: 1,
    },
    {
        field: "reporter.username",
        valueGetter: (params) => params.row.reporter ? params.row.reporter.username : '',
        headerName: "Username",
        flex: 0.5,
    },
    {
        field: "reporter.name",
        valueGetter: (params) => params.row.reporter ? params.row.reporter.name : '',
        headerName: "Name",
        flex: 0.5,
    },
    {
        field: "reporter.email",
        valueGetter: (params) => params.row.reporter ? params.row.reporter.email : '',
        headerName: "Email",
        flex: 1,
    },
    {
        field: "reporter.phoneNo",
        valueGetter: (params) => params.row.reporter ? params.row.reporter.phoneNo : '',
        headerName: "Phone No.",
        flex: 0.5,
    },
    {
        field: "type",
        headerName: "Report Type",
        flex: 0.5,
    },
    {
        field: 'reason',
        headerName: "Reason",
        flex: 0.5,
    },
    {
        // field: 'createdAt',
        headerName: "Reported At",
        flex: 0.5,
        valueGetter: (params) => {
            const date = new Date(params.row.createdAt);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
            });
        },
    }
];

return (
    <Box m="1.5rem 2.5rem">
        {/* Header */}

        {/* <Box display="flex" justifyContent="flex-start"> */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Header 
                    title="REPORTED USER DETAIL" 
                    subtitle={`Name: ${name} | Email: ${email} | Username: ${username} | Report Count: ${reportCount}`} 
            />

            <Button variant="contained" color="primary" size="medium" onClick={
                    async () => {
                        setIsLoadingSubmit(true); // Start loading before asynchronous operations

                        await disableUser(_id).then(() => {
                                setIsLoadingSubmit(false); // Stop loading after data is created
                                navigate('/reportedUsers', { replace: true });
                                window.location.reload();
                        });

                    }
            }  
            disabled={isLoadingSubmit}
            >
                {isLoadingSubmit ? <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} /> : 'Disable User'}
            </Button>
        </Box>
        <Box
            mt="40px"
            height="75vh"
            sx={{
                "& .MuiDataGrid-root": {
                    border: "none",
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: theme.palette.background.alt,
                    color: theme.palette.secondary[100],
                    borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: theme.palette.primary.light,
                },
                "& .MuiDataGrid-footerContainer": {
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.secondary[100],
                    borderTop: "none",
                },
                "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
                    color: `${theme.palette.secondary[200]} !important`,
                },
            }}
        >
                   {/* Grid table */}
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} />
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            {data && data.length > 0 ? (
              <DataGrid
                loading={isLoading || !data}
                getRowId={(row) => row._id}
                rows={data || []}
                columns={columns}
                sx={{ width: '100%' }}
              />
            ) : (
              <h1>No reported user details available</h1>
            )}
          </Box>
        )}
      </Box>
    
    </Box>
);
};

export default ReportedCustomerDetail;
